export default "__VITE_ASSET__BBfcnj3H__"